<template>
  <div v-if="pagination" class="d-flex justify-content-between">
    <div class="vc_pagination d_flex_start" >Showing {{ pagination.to ?? 0 }} of {{ pagination.total }} entries</div>
    <div class="vc_pagination d_flex_end" >
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item">
            <a id="prevPage" class="page-link" :class="{'disabled': pageData.current_page == 1}">
              <template v-if="pageData.current_page == 1">
                <i class="lni lni-chevron-left"></i>
              </template>
              <div v-else @click="changePage(Number(pageData.current_page) - 1)">
                <i class="lni lni-chevron-left"></i>
              </div>
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="javascript:void(0)" @click="changePage(page)">{{ page }}</a>
          </li>
          <li v-if="page +1 <= pageData.last_page" class="page-item">
            <a class="page-link" href="javascript:void(0)" @click="changePage(page+1)">{{ page + 1 }}</a>
          </li>
          <li class="page-item"><span class="page-link">...</span></li>
          <li><a class="page-link" href="javascript:void(0)" @click="changePage(pageData.last_page)">{{  pageData.last_page }}</a></li>

          <li class="page-item">
            <a class="page-link" id="nextPage" :class="{'disabled': pageData.current_page === pageData.last_page}">
              <template v-if="pageData.current_page === pageData.last_page">
                <i class="lni lni-chevron-right"></i>
              </template>
              <div v-else  @click="changePage(Number(pageData.current_page) + 1)">
                <i class="lni lni-chevron-right"></i>
              </div>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        pagination: {
            type: Object,
            required: false,
        }
    },
    computed: {
        pagesNumber() {
            var pagesArray = [];
            
            var start = Math.max(1, this.pageData.current_page - 1);
            var end = Math.min(this.pageData.current_page + 1, this.pageData.last_page);            

            if (this.pageData.current_page == 1) {
                start = 1;
                end = Math.min(3, this.pageData.last_page);
            }
            if (this.pageData.current_page == 2) {
                start = 1;
                end = Math.min(3, this.pageData.last_page);
            }
            if (this.pageData.current_page >= 2  && this.pageData.current_page <= this.pageData.last_page-1) {
                start = Number(this.pageData.current_page) - 1;
                end = Number(this.pageData.current_page) + 1;
            }
            if (this.pageData.current_page == this.pageData.last_page - 1) {
                start = Math.max((this.pageData.last_page - 2), 1);
                end = this.pageData.last_page;
            }
            if (this.pageData.current_page >= this.pageData.last_page) {
                start = Math.max((this.pageData.last_page - 2), 1);
                end = this.pageData.last_page;
            }
            for (var i = start; i <= end; i++) {
                pagesArray.push(i);
            }
            return pagesArray;
        },
    },
    data() {
        return {
            pageData: {...this.pagination},
            page: this.pagination ? this.pagination.current_page : 0
        }
    },
    watch: {
        pagination: {
            deep: true,
            handler() {
                this.pageData = {...this.pagination};
                this.page = this.pagination?.current_page;
            }
        }
    },
    methods: {
        changePage(page) {
            this.pageData.current_page = page;
            this.page = page;
            this.$emit('changePage', page);
        }
    }
}
</script>